'use client'
import { memo } from 'react'
import type { FC } from 'react'
import dynamic from 'next/dynamic'
import styled from 'styled-components'
import { useDeviceType } from '../hooks'
import { mq } from '../styles'

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

const Header = styled.header<{ $isTouchDevice: boolean }>`
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 6;
  grid-row: 1 / span 3;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  width: 100vw;

  ${mq.greaterThan('tablet')} {
    grid-column: 1 / span 12;
  }

  .player-mobile,
  .player-desktop {
    bottom: 0;
    height: 100vh;
    height: 100dvh;
    left: 0;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: 100ms opacity ease-out;
    user-select: none;
    width: 100vw;
  }

  div {
    &[data-vimeo-initialized='true'] {
      display: inline-block;
      height: 100vh !important;
      height: 100dvh !important;
      margin: 0;
      padding: 0;
      position: relative;
      width: 100vw !important;
      z-index: 1;
    }
  }

  .player-portrait,
  .player-landscape,
  iframe {
    aspect-ratio: 16 / 9;
    left: 0;
    position: absolute;
    top: 0;
  }

  .player-portrait {
    opacity: 1;
    aspect-ratio: 9 / 16;
    height: auto !important;
    width: 100% !important;

    @media (min-aspect-ratio: 16/9) {
      height: auto !important;
      width: 100% !important;
    }

    ${mq.greaterThan('desktop-xs')} {
      display: ${({ $isTouchDevice }) => !$isTouchDevice ? 'none' : 'block'};
      opacity: ${({ $isTouchDevice }) => !$isTouchDevice ? 0 : 1};
    }

    @media (min-aspect-ratio: 9/16) {
      display: block;
      opacity: 1;
    }
  }

  .player-landscape {
    display: ${({ $isTouchDevice }) => $isTouchDevice ? 'none' : 'block'};
    opacity: ${({ $isTouchDevice }) => $isTouchDevice ? 0 : 1};
    aspect-ratio: 16 / 9;
    height: auto !important;
    width: 100% !important;

    @media (max-aspect-ratio: 16/9) {
      height: 100% !important;
      width: auto !important;
    }

    @media (min-aspect-ratio: 16/9) {
      display: block;
      opacity: 1;
    }

    ${mq.greaterThan('desktop-xs')} {
      display: block;
      opacity: 1;
    }
  }
`

const video = {
  aspectRatio: {
    portrait: 9 / 16,
    landscape: 16 / 9
  },
  src: {
    'corso': {
      mobile: 'https://vimeo.com/835348443',
      desktop: 'https://vimeo.com/837949397'
    },
    'iluzione': {
      mobile: 'https://vimeo.com/835349209',
      desktop: 'https://vimeo.com/838290202'
    }
  }
}

interface iRestaurant {
  restaurant: 'corso' | 'iluzione'
}

export const HeaderRestaurant:FC<iRestaurant> = memo(({ restaurant }) => {
  const { isTouchDevice } = useDeviceType()
  // const [isVideoPortraitReady, setVideoPortraitReady] = useState(false)
  // const [isVideoLandscapeReady, setVideoLandscapeReady] = useState(false)

  // const orientation = useMemo(() => size.width > size.height ? 'landscape' : 'portrait', [size])
  // const src = useMemo(() => video.src[restaurant][(orientation === 'landscape') ? 'desktop' : 'mobile'], [orientation, restaurant])

  const onPortraitReady = () => {
    console.log('* video Portrait is ready to play')
    // setVideoPortraitReady(true)
  }
  const onLandscapeReady = () => {
    console.log('* video landscape is ready to play')
    // setVideoLandscapeReady(true)
  }
  // $isMobile={isMobile} $isVideoPortraitReady={isVideoPortraitReady} $isVideoLandscapeReady={isVideoLandscapeReady}
  return (
    <Header $isTouchDevice={isTouchDevice}>
      {isTouchDevice && <ReactPlayer key='p-port' className='player-portrait' src={video.src[restaurant].mobile} width={'100%'} height={'100%'} controls={false} volume={0} muted={true} loop={true} title={restaurant} playsInline={true} playing={true} onReady={onPortraitReady} />}
      {!isTouchDevice && <ReactPlayer key='p-land' className='player-landscape' src={video.src[restaurant].desktop} width={'100%'} height={'100%'} controls={false} volume={0} muted={true} loop={true} title={restaurant} playsInline={true} playing={true} onReady={onLandscapeReady} />}
    </Header>
  )
})
